import { adminAiFeedbackQueryKeys as e } from "./useAdminAiFeedbackQueryKeys.mjs";
import { useInfiniteListQuery as t, useQuery as n } from "@maat/store-hooks";
import { adminAiApi as r } from "@maat/api-ai";
//#region src/ai/admin/useAdminAiFeedbackQueries.ts
var i = (t) => n({
	queryKey: e.summary(t),
	queryFn: () => r.getFeedbackSummary(t)
}), a = (t = 30) => n({
	queryKey: e.timeseries(t),
	queryFn: () => r.getFeedbackTimeseries(t)
}), o = () => t({
	queryKey: e.comments(),
	fetchPage: (e) => r.listFeedbackComments({
		page: e,
		pageSize: 25
	}),
	key: "items"
});
//#endregion
export { o as useAdminAiFeedbackCommentsQuery, i as useAdminAiFeedbackSummaryQuery, a as useAdminAiFeedbackTimeseriesQuery };
